/* Werkbank-Variantentabelle (23.10.2026)
   Filter-Chips je Eigenschaft, Mengen −/+, Summenbalken, Bildwechsel bei eindeutigem Variantenbild.
   Der Weg in den Warenkorb ist derselbe wie in der alten Tabelle (templates/product.json bis 10/2026):
   1. Zeilen, deren Menge schon so im Warenkorb liegt, werden aus dem Formular genommen.
   2. Zeilen, die schon im Warenkorb liegen und geändert wurden, gehen einzeln über /cart/change.js.
   3. Danach wird das Formular normal an /cart/add geschickt (items[ID][quantity|id|properties][message]).
   Kundenname (Etikett): je Zeile ein Knopf [data-pp-etk]; er öffnet unter der Zeile ein Eingabefeld (Vorlage
   [data-pp-etk-tpl]). Jede Eingabe wird sofort in das versteckte Feld items[ID][properties][message] der Zeile
   geschrieben – das Formular schickt es also genauso mit wie früher das sichtbare Textfeld. */
(function () {
  'use strict';

  function zahl(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }

  function Tabelle(root) {
    this.root = root;
    this.sid = root.getAttribute('data-section');
    this.li = root.getAttribute('data-li') === 'true';
    this.tAb = root.getAttribute('data-t-ab') || '';
    this.form = root.querySelector('[data-pp-form]');
    this.rows = Array.prototype.slice.call(root.querySelectorAll('[data-pp-row]'));
    this.filter = {};
    this.etk = null; /* offenes Eingabefeld: { row, tr, input, btn } */
    var loc = (root.getAttribute('data-locale') || 'de');
    try {
      this.fmt = new Intl.NumberFormat(loc, { style: 'currency', currency: root.getAttribute('data-currency') || 'EUR' });
    } catch (e) {
      this.fmt = { format: function (x) { return x.toFixed(2).replace('.', ',') + ' €'; } };
    }
    this.sortiereChips();
    this.binde();
    this.handyStart();
    this.aktualisiere();
  }

  /* Chips mit Zahlenwerten (mm) aufsteigend sortieren – Reihenfolge der Optionen ist im Shop oft gemischt */
  Tabelle.prototype.sortiereChips = function () {
    this.root.querySelectorAll('[data-pp-frow]').forEach(function (row) {
      var chips = Array.prototype.slice.call(row.querySelectorAll('[data-pp-chip]')).filter(function (c) { return c.getAttribute('data-wert') !== ''; });
      var num = function (c) { return parseFloat(c.textContent.replace(',', '.')); };
      if (!chips.every(function (c) { return !isNaN(num(c)) && /^\s*[\d.,]+\s*mm\s*$/i.test(c.textContent); })) return;
      chips.sort(function (a, b) { return num(a) - num(b); }).forEach(function (c) { c.parentNode.appendChild(c); });
    });
  };

  Tabelle.prototype.binde = function () {
    var self = this;
    this.root.addEventListener('click', function (ev) {
      var gk = ev.target.closest('[data-pp-gkopf]');
      if (gk) { self.gruppeUmschalten(gk.closest('.pp-vt__gruppe')); return; }
      var etkBtn = ev.target.closest('[data-pp-etk]');
      if (etkBtn) { self.etkUmschalten(etkBtn.closest('[data-pp-row]')); return; }
      if (ev.target.closest('[data-pp-etk-ok]')) { self.etkSchliessen(true); return; }
      var chip = ev.target.closest('[data-pp-chip]');
      if (chip) { self.waehle(chip.getAttribute('data-spalte'), chip.getAttribute('data-wert')); return; }
      if (ev.target.closest('[data-pp-reset]')) { self.filter = {}; self.zeigeFilter(true); return; }
      var inc = ev.target.closest('[data-pp-inc]'), dec = ev.target.closest('[data-pp-dec]');
      if (inc || dec) {
        var input = (inc || dec).parentElement.querySelector('.pp-qty__input');
        if (input && !input.disabled) { self.schritt(input, inc ? 1 : -1); }
      }
    });
    this.root.addEventListener('change', function (ev) {
      if (ev.target.classList.contains('pp-qty__input')) {
        var v = Math.max(0, zahl(ev.target.value));
        var max = ev.target.getAttribute('data-max');
        if (max !== null && v > zahl(max)) v = zahl(max);
        ev.target.value = v;
      }
      self.aktualisiere();
    });
    this.root.addEventListener('input', function (ev) {
      if (ev.target.hasAttribute('data-pp-etk-input')) { self.etkUebernehmen(); return; }
      if (ev.target.name && ev.target.name.indexOf('[properties][message]') > -1) self.aktualisiere();
    });
    this.root.addEventListener('keydown', function (ev) {
      if (!ev.target.hasAttribute || !ev.target.hasAttribute('data-pp-etk-input')) return;
      /* Enter = fertig (nicht das Formular absenden), Esc = schließen */
      if (ev.key === 'Enter' || ev.keyCode === 13) { ev.preventDefault(); self.etkSchliessen(true); }
      else if (ev.key === 'Escape' || ev.key === 'Esc' || ev.keyCode === 27) { ev.preventDefault(); self.etkSchliessen(true); }
    });
    /* Klick außerhalb schließt das Eingabefeld (Wert bleibt) */
    document.addEventListener('click', function (ev) {
      if (!self.etk) return;
      if (self.etk.tr.contains(ev.target) || ev.target.closest('[data-pp-etk]')) return;
      self.etkSchliessen(false);
    });
    if (this.form) {
      this.form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (self.form.hasAttribute('data-pp-gesperrt')) return;
        self.absenden();
      });
    }
  };

  /* ---------- Kundenname (Etikett) ---------- */
  Tabelle.prototype.etkUmschalten = function (row) {
    if (!row) return;
    var offen = this.etk && this.etk.row === row;
    this.etkSchliessen(false);
    if (!offen) this.etkOeffnen(row);
  };

  Tabelle.prototype.etkOeffnen = function (row) {
    var tpl = this.root.querySelector('[data-pp-etk-tpl]');
    var btn = row.querySelector('[data-pp-etk]');
    var feld = row.querySelector('[data-pp-msg]');
    if (!tpl || !btn || !feld || btn.disabled) return;
    var tr = (tpl.content ? tpl.content.firstElementChild : tpl.firstElementChild).cloneNode(true);
    var td = tr.querySelector('td');
    if (td) td.colSpan = row.children.length;
    if (row.classList.contains('is-qty')) tr.classList.add('is-qty');
    var sku = tr.querySelector('[data-pp-etk-sku]'), skuQuelle = row.querySelector('.pp-vt__skunr');
    if (sku && skuQuelle) sku.textContent = skuQuelle.textContent;
    /* Handy-Gruppen: statt der Artikelnummer die Variante in Worten (Gruppe · Wert) */
    if (sku && this.gruppiert && row.getAttribute('data-pp-mtitel')) sku.textContent = row.getAttribute('data-pp-mtitel');
    var input = tr.querySelector('[data-pp-etk-input]');
    var id = 'PpEtk-' + this.sid + '-' + (row.getAttribute('data-variant') || '');
    input.id = id;
    var lab = tr.querySelector('[data-pp-etk-label]');
    if (lab) lab.setAttribute('for', id);
    input.value = feld.value;
    row.parentNode.insertBefore(tr, row.nextSibling);
    row.classList.add('is-etk');
    btn.setAttribute('aria-expanded', 'true');
    btn.setAttribute('aria-controls', id);
    this.etk = { row: row, tr: tr, input: input, btn: btn, feld: feld };
    try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    var r = tr.getBoundingClientRect();
    if (r.bottom > window.innerHeight - 90 || r.top < 0) { try { tr.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { tr.scrollIntoView(false); } }
  };

  /* Eingabe sofort ins versteckte Formularfeld schreiben */
  Tabelle.prototype.etkUebernehmen = function () {
    if (!this.etk) return;
    this.etk.feld.value = this.etk.input.value;
    this.etkAnzeigen(this.etk.row);
    this.aktualisiere();
  };

  Tabelle.prototype.etkAnzeigen = function (row) {
    var btn = row.querySelector('[data-pp-etk]'), feld = row.querySelector('[data-pp-msg]');
    if (!btn || !feld) return;
    var wert = feld.value.trim();
    if (!btn.hasAttribute('data-label')) btn.setAttribute('data-label', btn.getAttribute('aria-label') || '');
    btn.classList.toggle('is-voll', wert !== '');
    btn.setAttribute('aria-label', btn.getAttribute('data-label') + (wert ? ': ' + wert : ''));
    var t = btn.querySelector('[data-pp-etk-text]');
    if (t) t.textContent = wert;
    var z = row.querySelector('[data-pp-etk-zeile]'), zt = row.querySelector('[data-pp-etk-zeiletext]');
    if (zt) zt.textContent = wert;
    if (z) z.hidden = wert === '';
  };

  Tabelle.prototype.etkSchliessen = function (fokus) {
    var e = this.etk;
    if (!e) return;
    this.etk = null;
    e.feld.value = e.input.value.trim();
    this.etkAnzeigen(e.row);
    if (e.tr.parentNode) e.tr.parentNode.removeChild(e.tr);
    e.row.classList.remove('is-etk');
    e.btn.setAttribute('aria-expanded', 'false');
    e.btn.removeAttribute('aria-controls');
    if (fokus) { try { e.btn.focus({ preventScroll: true }); } catch (x) { e.btn.focus(); } }
    this.aktualisiere();
  };

  /* Mengenregel der Variante (quantity_rule): erster Klick auf + springt auf das Minimum, danach in Schritten */
  Tabelle.prototype.schritt = function (input, richtung) {
    var q = zahl(input.value), min = Math.max(1, zahl(input.getAttribute('data-min')) || 1),
      step = Math.max(1, zahl(input.getAttribute('data-step')) || 1), max = input.getAttribute('data-max');
    if (richtung > 0) q = q < min ? min : q + step;
    else q = q - step < min ? 0 : q - step;
    if (max !== null && q > zahl(max)) q = zahl(max);
    input.value = q;
    this.aktualisiere();
  };

  Tabelle.prototype.waehle = function (spalte, wert) {
    if (wert) this.filter[spalte] = wert; else delete this.filter[spalte];
    this.zeigeFilter(false);
  };

  Tabelle.prototype.zeigeFilter = function (zurueck) {
    this.etkSchliessen(false);
    var f = this.filter, keys = Object.keys(f), sichtbar = [];
    var rows = this.rows;
    this.root.querySelectorAll('[data-pp-chip]').forEach(function (c) {
      var spalte = c.getAttribute('data-spalte'), wert = c.getAttribute('data-wert');
      var on = (f[spalte] || '') === wert;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
      /* Chips ohne Treffer zur übrigen Auswahl deaktivieren („Alle“ und der gewählte Chip bleiben aktiv) */
      var leer = false;
      if (wert !== '' && !on) {
        leer = !rows.some(function (r) {
          if (r.getAttribute('data-' + spalte) !== wert) return false;
          return keys.every(function (k) { return k === spalte || r.getAttribute('data-' + k) === f[k]; });
        });
      }
      c.disabled = leer;
      c.classList.toggle('is-leer', leer);
    });
    this.rows.forEach(function (r) {
      var ok = keys.every(function (k) { return r.getAttribute('data-' + k) === f[k]; });
      r.hidden = !ok;
      if (ok) sichtbar.push(r);
    });
    var shown = this.root.querySelector('[data-pp-shown]');
    if (shown) shown.textContent = sichtbar.length;
    var reset = this.root.querySelector('[data-pp-reset]');
    if (reset) reset.hidden = keys.length === 0;
    var leer = this.root.querySelector('[data-pp-empty]');
    if (leer) leer.hidden = sichtbar.length > 0;

    /* Hauptbild: nur wechseln, wenn alle sichtbaren Zeilen dasselbe Variantenbild haben (z. B. eine Farbe gewählt) */
    var medien = sichtbar.map(function (r) { return r.getAttribute('data-media') || ''; });
    var eins = medien.length && medien.every(function (m) { return m && m === medien[0]; }) ? medien[0] : '';
    if (eins && keys.length) this.zeigeBild(eins);
    else if (zurueck && this.rows.length) this.zeigeErstesBild();
  };

  Tabelle.prototype.zeigeBild = function (mediaId) {
    var g = document.getElementById('MediaGallery-' + this.sid);
    if (!g || typeof g.setActiveMedia !== 'function') return;
    if (!g.querySelector('[data-media-id="' + mediaId + '"]')) return;
    try { g.setActiveMedia(mediaId, false); } catch (e) { /* Galerie ohne Vorschaubilder */ }
  };

  Tabelle.prototype.zeigeErstesBild = function () {
    var g = document.getElementById('MediaGallery-' + this.sid);
    var first = g && g.querySelector('[data-media-id]');
    if (first) this.zeigeBild(first.getAttribute('data-media-id'));
  };

  /* Stückpreis je Menge aus echten quantity_price_breaks der Variante */
  Tabelle.prototype.preis = function (el, q) {
    var basis = zahl(el.getAttribute('data-pp-price')), stufe = null, liste = [];
    try { liste = JSON.parse(el.getAttribute('data-pp-staffel') || '[]'); } catch (e) { liste = []; }
    liste.forEach(function (s) { if (q >= s[0] && (!stufe || s[0] > stufe[0])) stufe = s; });
    return { cent: stufe ? stufe[1] : basis, ab: stufe ? stufe[0] : 0 };
  };

  Tabelle.prototype.aktualisiere = function () {
    var self = this, summe = 0, stueck = 0, varianten = 0, namen = 0;
    this.rows.forEach(function (r) {
      var input = r.querySelector('.pp-qty__input');
      var q = input ? Math.max(0, zahl(input.value)) : 0;
      var name = r.querySelector('input[name$="[properties][message]"]');
      r.classList.toggle('is-qty', q > 0);
      if (self.etk && self.etk.row === r) self.etk.tr.classList.toggle('is-qty', q > 0);
      var pe = r.querySelector('[data-pp-price]');
      if (pe) {
        var p = self.preis(pe, Math.max(q, 1));
        pe.textContent = self.fmt.format(p.cent / 100);
        var tier = r.querySelector('[data-pp-tier]');
        if (tier) tier.textContent = p.ab ? self.tAb + ' ' + p.ab : '';
        summe += p.cent * q;
      }
      if (q > 0) {
        stueck += q; varianten += 1;
        if (name && name.value.trim() !== '') namen += 1;
      }
    });
    var set = function (sel, v) { var e = self.root.querySelector(sel); if (e) e.textContent = v; };
    set('[data-pp-sum]', this.fmt.format(summe / 100));
    set('[data-pp-pieces]', stueck);
    set('[data-pp-variants]', varianten);
    var wort = this.root.querySelector('[data-pp-variants-wort]');
    if (wort) wort.textContent = wort.getAttribute(varianten === 1 ? 'data-eins' : 'data-mehr');
    set('[data-pp-labelled]', namen);
    if (this.gruppiert) this.gruppenZaehlen();
  };

  /* ---------- Handy (< 750 px): Varianten in aufklappbaren Gruppen ----------
     Dieselben <tr> (dieselben Formularfelder) werden nur umgehängt: je Gruppe ein eigenes <tbody>
     mit einer Kopfzeile. Gruppe = alle Optionen außer der letzten, Zeile = Wert der letzten Option.
     Eine Option oder eine Variante: keine Gruppen, die Zeilen stehen direkt untereinander.
     Ab 750 px wird alles in die ursprüngliche Reihenfolge zurückgehängt (Desktop-Tabelle unverändert). */
  function json(el, attr) { try { return JSON.parse(el.getAttribute(attr) || '[]'); } catch (e) { return []; } }
  /* Text mit Umbruchstelle nach „/“ (Farbnamen wie „Schwarz/Kristall“ nie mitten im Wort trennen) */
  function text(el, t) { String(t).split('/').forEach(function (teil, i) { if (i) { el.appendChild(document.createTextNode('/')); el.appendChild(document.createElement('wbr')); } el.appendChild(document.createTextNode(teil)); }); }
  function zahlen(t) { return (String(t).match(/\d+(?:[.,]\d+)?/g) || []).map(function (x) { return parseFloat(x.replace(',', '.')); }); }

  Tabelle.prototype.handyStart = function () {
    var self = this;
    this.tbody0 = this.root.querySelector('.pp-vt__table > tbody');
    if (!this.tbody0 || !window.matchMedia) return;
    this.namen = json(this.root, 'data-pp-onamen');
    this.farbpos = (this.root.getAttribute('data-pp-farbpos') || ',');
    this.komma = this.root.getAttribute('data-pp-komma') === 'true';
    this.standard = this.root.getAttribute('data-pp-standard') === 'true';
    this.offen = null;
    this.mq = window.matchMedia('(max-width: 749px)');
    var f = function () { self.handyModus(self.mq.matches); };
    if (this.mq.addEventListener) this.mq.addEventListener('change', f); else if (this.mq.addListener) this.mq.addListener(f);
    f();
  };

  Tabelle.prototype.wert = function (w, pos) {
    w = String(w || '').trim();
    if (this.farbpos.indexOf(',' + pos + ',') > -1) return w;
    /* „6 mm / 3 mm“ → „6 / 3 mm“, Dezimalkomma außer EN */
    var teile = w.split(' / ').map(function (x) { return x.trim(); });
    if (teile.length > 1 && teile.every(function (x) { return / mm$/.test(x); })) w = teile.map(function (x) { return x.replace(/ mm$/, ''); }).join(' / ') + ' mm';
    if (this.komma) w = w.replace(/(\d)\.(\d)/g, '$1,$2');
    return w;
  };

  Tabelle.prototype.handyModus = function (an) {
    if (an && !this.handy) this.handyBauen();
    else if (!an && this.handy) this.handyAbbauen();
  };

  Tabelle.prototype.handyBauen = function () {
    var self = this, rows = this.rows;
    this.etkSchliessen(false);
    if (Object.keys(this.filter).length) { this.filter = {}; this.zeigeFilter(false); }
    var opts = rows.map(function (r) { return json(r, 'data-pp-opts').map(function (x) { return String(x).trim(); }); });
    var n = opts.length ? opts[0].length : 0;
    var farbe = function (pos) { return self.farbpos.indexOf(',' + pos + ',') > -1; };
    /* Wert der letzten Option groß in der Zeile */
    rows.forEach(function (r, i) {
      var td = r.querySelector('.pp-vt__sku'); if (!td) return;
      var alt = td.querySelector('.pp-vt__mwert'); if (alt) alt.remove();
      if (self.standard || !n) return;
      var span = document.createElement('span');
      span.className = 'pp-vt__mwert';
      var w = self.wert(opts[i][n - 1], n);
      if (farbe(n)) {
        span.classList.add('pp-vt__mwert--farbe');
        var sw = td.querySelector('.pp-vt__mfarbe .pp-swatch');
        if (sw) span.appendChild(sw.cloneNode(true));
        var t = document.createElement('span'); text(t, w); span.appendChild(t);
      } else if (/ mm$/.test(w)) {
        span.appendChild(document.createTextNode(w.replace(/ mm$/, '') + ' '));
        var u = document.createElement('small'); u.textContent = 'mm'; span.appendChild(u);
      } else span.textContent = w;
      td.insertBefore(span, td.firstChild);
    });
    /* Gruppen bilden (Reihenfolge des ersten Auftretens) */
    var gruppen = [], idx = {};
    if (n >= 2 && rows.length > 1) {
      rows.forEach(function (r, i) {
        var key = opts[i].slice(0, n - 1).join('\u0001');
        if (!(key in idx)) { idx[key] = gruppen.length; gruppen.push({ key: key, werte: opts[i].slice(0, n - 1), rows: [] }); }
        gruppen[idx[key]].rows.push(r);
      });
      if (gruppen.length < 2) gruppen = [];
    }
    this.gruppen = gruppen;
    this.gruppiert = gruppen.length > 0;
    rows.forEach(function (r, i) {
      if (!n || self.standard) return;
      var teile = opts[i].map(function (w, k) { return self.wert(w, k + 1); });
      /* Eingabefeld steht direkt unter der Zeile in ihrer Gruppe – der Wert der letzten Option reicht */
      r.setAttribute('data-pp-mtitel', self.gruppiert ? teile[n - 1] : teile.join(' · '));
    });
    if (this.gruppiert) {
      var spalten = rows[0].children.length;
      var istOffen = this.offen || {};
      var ersteOffen = !this.offen;
      var nach = this.tbody0;
      gruppen.forEach(function (g, gi) {
        /* Zeilen in der Gruppe nach Zahlenwerten (Länge, dann Kugel) – Shop-Reihenfolge ist oft gemischt */
        var z = g.rows.map(function (r) { return zahlen(json(r, 'data-pp-opts')[n - 1]); });
        if (z.every(function (a) { return a.length; })) {
          var pos = g.rows.map(function (r, i) { return i; });
          pos.sort(function (a, b) { for (var k = 0; k < Math.max(z[a].length, z[b].length); k++) { var d = (z[a][k] || 0) - (z[b][k] || 0); if (d) return d; } return a - b; });
          g.rows = pos.map(function (i) { return g.rows[i]; });
        }
        var tb = document.createElement('tbody');
        tb.className = 'pp-vt__gruppe';
        var tr = document.createElement('tr'); tr.className = 'pp-vt__gkopf';
        var td = document.createElement('td'); td.colSpan = spalten;
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'pp-vt__gbtn'; btn.setAttribute('data-pp-gkopf', '');
        /* Name: Farbe, sonst erste Option mit Namen; darunter die übrigen Gruppenwerte (ohne Anzahl, Stephan 25.10.2026) */
        var fk = -1;
        g.werte.forEach(function (w, k) { if (fk < 0 && farbe(k + 1)) fk = k; });
        var name, meta = [];
        if (fk >= 0) {
          var sw = g.rows[0].querySelector('.pp-vt__mfarbe .pp-swatch');
          if (sw) { var s = sw.cloneNode(true); s.classList.add('pp-vt__gfarbe'); btn.appendChild(s); }
          name = self.wert(g.werte[fk], fk + 1);
        } else {
          fk = 0;
          name = (self.namen[0] ? self.namen[0] + ' ' : '') + self.wert(g.werte[0], 1);
        }
        g.werte.forEach(function (w, k) { if (k !== fk) meta.push((self.namen[k] ? self.namen[k] + ' ' : '') + self.wert(w, k + 1)); });
        var txt = document.createElement('span'); txt.className = 'pp-vt__gtext';
        var b1 = document.createElement('span'); b1.className = 'pp-vt__gname'; text(b1, name);
        var b2 = document.createElement('span'); b2.className = 'pp-vt__gmeta pp-mono'; b2.textContent = meta.join(' · ');
        txt.appendChild(b1); txt.appendChild(b2); btn.appendChild(txt);
        var badge = document.createElement('span'); badge.className = 'pp-vt__gbadge pp-mono'; badge.hidden = true; btn.appendChild(badge);
        var zeichen = document.createElement('span'); zeichen.className = 'pp-vt__gzeichen'; zeichen.setAttribute('aria-hidden', 'true'); btn.appendChild(zeichen);
        td.appendChild(btn); tr.appendChild(td); tb.appendChild(tr);
        g.rows.forEach(function (r) { tb.appendChild(r); });
        g.tbody = tb; g.btn = btn; g.badge = badge; g.zeichen = zeichen;
        nach.parentNode.insertBefore(tb, nach.nextSibling); nach = tb;
        var q = g.rows.some(function (r) { var inp = r.querySelector('.pp-qty__input'); return inp && zahl(inp.value) > 0; });
        g.offen = ersteOffen ? (gi === 0 || q) : (!!istOffen[g.key] || q);
        self.gruppeSetzen(g);
      });
      this.tbody0.classList.add('is-leer');
    }
    this.root.classList.add('pp-vt--m');
    this.handy = true;
    this.aktualisiere();
  };

  Tabelle.prototype.handyAbbauen = function () {
    var self = this;
    this.etkSchliessen(false);
    if (this.gruppiert) {
      this.offen = {};
      this.gruppen.forEach(function (g) { self.offen[g.key] = g.offen; });
      this.rows.forEach(function (r) { self.tbody0.appendChild(r); });
      this.gruppen.forEach(function (g) { if (g.tbody.parentNode) g.tbody.parentNode.removeChild(g.tbody); });
      this.tbody0.classList.remove('is-leer');
    }
    this.gruppen = []; this.gruppiert = false; this.handy = false;
    this.root.classList.remove('pp-vt--m');
  };

  Tabelle.prototype.gruppeSetzen = function (g) {
    g.tbody.classList.toggle('is-zu', !g.offen);
    g.btn.setAttribute('aria-expanded', g.offen ? 'true' : 'false');
    g.zeichen.textContent = g.offen ? '−' : '+';
  };

  Tabelle.prototype.gruppeUmschalten = function (tb) {
    var g = (this.gruppen || []).filter(function (x) { return x.tbody === tb; })[0];
    if (!g) return;
    if (this.etk && tb.contains(this.etk.row)) this.etkSchliessen(false);
    g.offen = !g.offen;
    this.gruppeSetzen(g);
  };

  Tabelle.prototype.gruppenZaehlen = function () {
    this.gruppen.forEach(function (g) {
      var summe = 0;
      g.rows.forEach(function (r) { var inp = r.querySelector('.pp-qty__input'); if (inp) summe += Math.max(0, zahl(inp.value)); });
      g.badge.textContent = summe > 0 ? String(summe) : '';
      g.badge.hidden = summe === 0;
      g.tbody.classList.toggle('is-qty', summe > 0);
    });
  };

  /* Ablauf wie bisher (siehe oben) */
  Tabelle.prototype.absenden = function () {
    var form = this.form;
    this.etkSchliessen(false);
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    var weg = function (input) {
      [input.name.replace('[quantity]', '[id]'), input.name.replace('[quantity]', '[properties][message]')].forEach(function (n) {
        var e = form.querySelector('[name="' + n + '"]');
        if (e) e.remove();
      });
      var box = input.closest('.pp-qty');
      input.remove();
      if (box) box.classList.add('is-sent');
    };
    var inputs = Array.prototype.slice.call(form.querySelectorAll('input[data-original_qty]'));
    inputs.forEach(function (input) {
      var orig = input.getAttribute('data-original_qty');
      if (orig == input.value && orig != '0') weg(input);
    });
    var geaendert = inputs.filter(function (input) {
      var orig = input.getAttribute('data-original_qty');
      return input.parentElement && orig != input.value && orig != '0';
    });
    var kette = Promise.resolve();
    geaendert.forEach(function (input) {
      kette = kette.then(function () {
        return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: input.getAttribute('data-key'), quantity: input.value })
        }).then(function (r) { return r.json(); }).then(function () { weg(input); })
          .catch(function (e) { console.error('Warenkorb-Änderung fehlgeschlagen', e); });
      });
    });
    kette.then(function () { HTMLFormElement.prototype.submit.call(form); });
  };

  /* Technische Daten: Werte in mm aufsteigend */
  function sortiereTechnik() {
    document.querySelectorAll('[data-pp-sort]').forEach(function (dd) {
      var teile = dd.textContent.split(' · ').map(function (x) { return x.trim(); });
      var num = function (x) { return parseFloat(x.replace(',', '.')); };
      if (teile.length < 2 || !teile.every(function (x) { return /^[\d.,]+\s*mm$/i.test(x); })) return;
      dd.textContent = teile.sort(function (a, b) { return num(a) - num(b); }).join(' · ');
    });
  }

  /* Handy: Summenleiste ist fest unten (position: fixed) – Seite unten um ihre Höhe verlängern,
     damit sie nichts vom Fußbereich verdeckt */
  function platzFuerLeiste() {
    var bar = document.querySelector('.pp-vt [data-pp-sumbar]');
    if (!bar) return;
    var fest = window.getComputedStyle(bar).position === 'fixed';
    document.body.style.paddingBottom = fest ? bar.offsetHeight + 'px' : '';
  }

  function init() {
    sortiereTechnik();
    platzFuerLeiste();
    if (!window.__ppVtResize) {
      window.__ppVtResize = true;
      window.addEventListener('resize', platzFuerLeiste);
    }
    document.querySelectorAll('.pp-vt').forEach(function (el) {
      if (el.__ppVt) return;
      el.__ppVt = new Tabelle(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
